<template>
    <b-container fluid class="mt--7">
        <list-items v-if="isList" title="Warehouse Inventory" ref="table">
        </list-items>
    </b-container>
</template>
<script>
import ListItems from './ListItems'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import showItemHelper from '@/mixins/showItemHelper'

export default {
    name: 'SectionItems',
    components: {
        ListItems,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    created() {},
    computed: {},

    methods: {
        alertSuccess(message) {
            this.doToast('Success', message, 'success')
        },
    },
}
</script>
<style></style>
